import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import RewardGlyph from "../../assets/RewardGlyph";
import useTranslations from "../../i18n/useTranslations";
import type { Tier } from "../../types";
import Pill from "../Pill";
import getTierLevel from "./getTierLevel";

type Props = {
  tier: Tier;
  locked: boolean;
};

const TierFooter: FC<Props> = ({ tier, locked }) => {
  const {
    state: { progress, currentPoints = 0 },
  } = useRewardCenter();
  const t = useTranslations();
  const { milestones, next } = getTierLevel(tier, currentPoints);

  if (locked) {
    return (
      <div
        data-slot="tier-footer"
        className="flex items-center justify-between"
      >
        <Pill>{t("reward_center.tier.locked")}</Pill>
        <Pill>
          <RewardGlyph name="lock" />
          {t("reward_center.tier.levels_to_clear", {
            count: milestones.length,
          })}
        </Pill>
      </div>
    );
  }

  return (
    <div
      data-slot="tier-footer"
      className="flex items-center justify-between gap-2.5"
    >
      <Pill>{Math.floor(progress || 0)}%</Pill>
      {next && (
        <Pill>
          {t("reward_center.tier.xp_to_next", {
            xp: (
              Number(next.points) - Math.floor(currentPoints)
            ).toLocaleString(),
            name: next.name,
          })}
        </Pill>
      )}
    </div>
  );
};

export default TierFooter;
